import axios from 'axios';

module.exports = {
  methods: {
    submitPickupRequest (gaEvent) {
      this.status = 'LOADING';

      axios.post(this.formAction, this.pickupDetails,
      {
        headers: {
          'RequestVerificationToken': this.token
        }
      })
      .then((res) => {
        if (res.data.status == 'OK') {
          // Change the status on a timeout to prevent a flicker if loaded fast
          setTimeout(() => {
            this.status = 'COMPLETE';

            dataLayer.push({ 
              'event': gaEvent,
              'subType': 'Success'
            });

           this.paymentUrl = res.data.result.paymentUrl;
          }, 500);

        

        }  else {
          this.status = 'ERR'

          dataLayer.push({ 
            'event': gaEvent,
            'subType': 'Fail'
          });
        }
      })
      .then(() => {
        const el = document.querySelector(`[data-step="${this.currentStep}"]`),
              heading = el.querySelector('h2');

        heading.setAttribute('tabindex', -1)

        setTimeout(() => {
          heading.focus();
        }, 200);
      })
      .catch((error) => {
        console.log(error);
        this.status = 'ERR'
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/js/pickup/mixins/method-submitPickupRequest.js